module.exports = __webpack_public_path__ + "img/login_icon.185a14b1.png";